import React from 'react'
import VideoLoop from '../VideoLoop'
import styled from 'styled-components'

const FullVideoLoop = styled.div`
    width: 100%;
    video {
        max-width: 100%;
    }
`

const FullwidthVideoLoop = ({src, description}) => {
    return (
        <FullVideoLoop className="row-component">
            <VideoLoop src={src} description={description} />
        </FullVideoLoop>
    )
}

export default FullwidthVideoLoop
